import { call, put, takeLatest } from "redux-saga/effects";

import { setSnackbar } from "../generals/actionCreators";
import { locationsApi } from "@src/service/locations";
import { isLocationIdExists } from "@src/utils/utils";
import { AppManagerActionTypes } from "./actionTypes";
import { getRequestError } from "@src/utils/getRequestError";
import { setFullRefreshLoader } from "./actionCreators";
import { ILocation, IRestaurantGroup } from "./types";

export function* fetchAllRestaurantGroupsRequest(): any {
  try {
    yield put(setFullRefreshLoader(true));

    const { data: restaurantGroups } = yield call(
      locationsApi.getRestaurantsGroup
    );

    let currRestGroupId = localStorage.getItem("currRestGroupId") ?? "";

    const includesRestaurantGroupId = restaurantGroups?.some(
      (item: IRestaurantGroup) => currRestGroupId === item.id
    );

    if (!includesRestaurantGroupId) {
      currRestGroupId = restaurantGroups?.[0]?.id;
      localStorage.setItem("currRestGroupId", currRestGroupId);
    }

    const locations: ILocation[] = restaurantGroups?.find(
      (restGroup: any) => restGroup?.id === currRestGroupId
    )?.locations;

    let currLocation = localStorage.getItem("currLocation") ?? "";

    if (!isLocationIdExists(currLocation, locations)) {
      currLocation = locations?.[0]?.restaurant_id;
    }

    yield put({
      type: AppManagerActionTypes.APP_FETCH_RESTAURANT_GROUPS_SUCCESS,
      payload: { restaurantGroups, currRestGroupId },
    });
    yield put({
      type: AppManagerActionTypes.APP_FETCH_ALL_LOCATIONS_SUCCESS,
      payload: {
        allLocations: { data: locations },
        locations,
        currLocation,
      },
    });

    localStorage.setItem("currRestGroupId", currRestGroupId);
    localStorage.setItem("currLocation", currLocation);

    yield put(setFullRefreshLoader(false));
  } catch (e) {
    yield put(
      setSnackbar({
        visible: true,
        status: "error",
        message: getRequestError(e),
      })
    );

    yield put(setFullRefreshLoader(false));
  }
}

export function* appManagerSagas(): any {
  yield takeLatest(
    AppManagerActionTypes.APP_FETCH_RESTAURANT_GROUPS_SAGA,
    fetchAllRestaurantGroupsRequest
  );
}
